import { Button }                     from "@mantine/core";
import { useViewportSize }            from "@mantine/hooks";
import dayjs                          from "dayjs";
import Link                           from "next/link";
import React, { useEffect, useState } from "react";

import { SecondaryButton } from "_components/atoms/button";
import Image               from "_components/atoms/image";
import Typography          from "_components/atoms/typography";
import useStyles           from "_styles/pages/blogs/featuredPost.js";

const featuredPost = ( { categories } ) => {
	const [ featuredPost, setFeaturedPost ] = useState ();
	const { width }                         = useViewportSize ();
	let deviceMobileView                    = width <= 600;
	const { classes }                       = useStyles ( { deviceMobileView } );

	useEffect ( ( ) => {
		if ( !categories ) return;

		const selectedPost = categories.find ( cat => cat.name === "Featured" )?.posts?.[0];

		setFeaturedPost ( { ...selectedPost, categoryName: "Featured" } );
	}, [ categories ] );

	if ( !featuredPost?.title && !featuredPost?.id ) return null;

	return (
		<Link className = { classes?.featuredPostContainer }
			href           = { `/blogs/${ featuredPost?.slug }/${ featuredPost?.id }` }
		>
			<div className = { classes.infoContainer }>
				<Typography
					className = { classes.featuredText }
					title     = { "Featured" }
				/>

				<Typography
					className = { classes.heading }
					title     = { featuredPost?.title }
				/>

				<div
					className               = { classes.postContent }
					dangerouslySetInnerHTML = { { __html: featuredPost?.content } }
				/>

				<div className = { classes.tagsContainer }>
					<Typography
						className = { classes.dateTag }
						title     = { dayjs ( featuredPost?.date ).format ( "MMMD" ) }
					/>

					<div className = { classes.seperator } />

					<Typography
						className = { classes.nameTag }
						title     = { featuredPost?.categoryName }
					/>
				</div>

				<SecondaryButton
					className = { classes.readingButton }
					title     = { "Continue Reading" }
					variant   = "outline"
				>
					Continue Reading
				</SecondaryButton>

			</div>

			<div className = { classes.imageContainer }>
				<Image
					className = { classes.featuredImg }
					src       = { featuredPost?.featuredImage }
				/>
			</div>
		</Link>
	);
};

export default featuredPost;